import { reaction } from "mobx";
import { useEffect } from "react";
import { useGlobalStore } from "@/store/hooks";
import { uniq } from "lodash";
import { useOrderManagementStore } from "../store/OrderManagementStore";

export const useDropshippingEffect = () => {
    const orderManagementStore = useOrderManagementStore();
    const globalStore = useGlobalStore();

    useEffect(() => {
        return reaction(
            () => orderManagementStore.table.orders,
            (orders) => {
                if (!orders?.length) {
                    return;
                }

                const currentOrderSupplierShopIds: number[] = [];
                const currentOrderRetailerShopIds: number[] = [];

                let shopIds: number[] = [];

                orders?.forEach((order) => {
                    shopIds.push(order.shopId);

                    const supplierShopId = order.retailerDropShippingInfo?.supplierShopId;
                    const retailerShopId = order.supplierDropShippingInfo?.retailerShopId;

                    if (supplierShopId) {
                        currentOrderSupplierShopIds.push(supplierShopId);
                    }

                    if (retailerShopId) {
                        currentOrderRetailerShopIds.push(retailerShopId);
                    }
                });

                shopIds = uniq(shopIds);

                if (globalStore.companyRoleStore.isRetailer && currentOrderSupplierShopIds.length) {
                    for (let i = 0; i < shopIds.length; i++) {
                        const shopId = shopIds[i];

                        orderManagementStore.retailerPartnershipsStore.ensureEstablishedPartnerships(shopId);
                    }
                }

                if (globalStore.companyRoleStore.isSupplier && currentOrderRetailerShopIds.length) {
                    for (let i = 0; i < shopIds.length; i++) {
                        const shopId = shopIds[i];

                        orderManagementStore.supplierPartnershipsStore.ensureEstablishedPartnerships(shopId);
                    }
                }
            },
        );
    }, []);
};
